import RankTypes from './types';
import { Reducer } from 'redux';
import { FoodRankState, FoodRankDispatchAction } from './state';

const initialState : FoodRankState = {
    rank: ''
}

const RankReducer : Reducer<FoodRankState, FoodRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;